// TODO: Раскомментировать если через defineProperty будут проблемы
// function spliceItem(array, value) {
//     this.splice(this.findIndex(item => item === value), 1);
// }

Object.defineProperty(Array.prototype, 'spliceItem', {
    enumerable: false,
    value: function(value) {
        return this.splice(this.findIndex(item => item === value), 1);
    }
});

export default {
    data() {
        return {
            inputs: [],
        };
    },
    methods: {
        addInput(input) {
            this.inputs.push(input);
            input.$on('hook:beforeDestroy', () => this.removeInput(input));
        },
        removeInput(input) {
            this.inputs.spliceItem(input);
        },
    }
}